module.exports = __webpack_public_path__ + "media/images/bkg-dashboard-125890743a23cc167917e2e111a47cfa.png";